import { Cross } from "lucide-react";
import { VERSES } from "../lib/api";

export const ScriptureMarquee = () => {
  const items = [...VERSES, ...VERSES];
  return (
    <div className="relative py-6 border-y border-[#E84C4C]/15 bg-[#FFF5F2] overflow-hidden" data-testid="scripture-marquee">
      <div className="marquee-track">
        {items.map((v, i) => (
          <div key={i} className="flex items-center gap-6 px-8 whitespace-nowrap">
            <span className="font-montserrat italic font-light text-[#120716]/70 text-sm md:text-base">"{v.text}"</span>
            <span className="font-orbitron text-xs tracking-widest text-[#E84C4C]">{v.ref}</span>
            <Cross className="w-4 h-4 text-[#E84C4C]" fill="currentColor" />
          </div>
        ))}
      </div>
    </div>
  );
};
